import {ManualKpi, ManualKpiResolution} from '@domain/shifthandover'
import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

const QueryKey = 'manual-kpis'

export const useManualKpis = (
  plantId: string,
  resolution: ManualKpiResolution,
  timestamp: Iso8601,
  onSuccess: (data: ManualKpi[]) => void
) => {
  const path = `/shifthandover/${plantId}/kpi/${resolution}/${timestamp}`

  const query = useQuery<ManualKpi[], AxiosError>({
    queryKey: [QueryKey, path],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ManualKpi[]>(path, {signal})
      return response.data
    }
  })

  useEffect(() => {
    if (query.isSuccess) {
      onSuccess(query.data)
    }
  }, [query.isSuccess, onSuccess, query.data])

  return query
}
